import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import portalApi from "@/lib/portalApi";

export default function PortalRedeem() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const [status, setStatus] = useState("redeeming");
    const [error, setError] = useState("");

    useEffect(() => {
        const token = params.get("token");
        if (!token) { setStatus("error"); setError("Missing token"); return; }
        portalApi.post("/portal/redeem", { token })
            .then(({ data }) => {
                localStorage.setItem("forge_portal_token", data.token);
                localStorage.setItem("forge_portal_user", JSON.stringify(data.portal_user));
                setStatus("ok");
                setTimeout(() => nav("/portal/projects", { replace: true }), 400);
            })
            .catch((err) => {
                setStatus("error");
                setError(err.response?.data?.detail || "Link is invalid or expired.");
            });
    }, [params, nav]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4">
            <div className="text-center max-w-md" data-testid="portal-redeem">
                {status === "redeeming" && <div className="text-sm text-muted-foreground">Signing you in…</div>}
                {status === "ok" && <div className="text-sm">Signed in! Redirecting to your portal…</div>}
                {status === "error" && (
                    <div data-testid="portal-redeem-error">
                        <div className="text-lg tracking-tight mb-2">Sign-in failed</div>
                        <div className="text-sm text-muted-foreground mb-4">{error}</div>
                        <button onClick={() => nav("/portal/login")} className="text-xs underline">Request a new link</button>
                    </div>
                )}
            </div>
        </div>
    );
}
